import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "prisoners-page",
  class: "bg-black text-white py-12"
}
const _hoisted_2 = { class: "container mx-auto" }

import useAirtable from '../../composables/useAirtable';
import {ref, watch, computed, onMounted, onUnmounted} from "vue";
import {PrisonerRecord} from "@/@types/types";
import CardComponent from "@/components/database/CardComponent.vue";
import FiltersComponent from "@/components/database/FiltersComponent.vue";
import DatabaseMap from "@/components/database/DatabaseMap.vue";
import {useFilter} from "@/composables/useFilter";

export default /*#__PURE__*/_defineComponent({
  __name: 'DatabaseComponent',
  async setup(__props) {

let __temp: any, __restore: any

const { records, fetchRecords, filterFieldsObj } = useAirtable();
;(
  ([__temp,__restore] = _withAsyncContext(() => fetchRecords())),
  await __temp,
  __restore()
);
const filterObject = ref<any>({});
const cleanFilterObject = ref<Record<any, any>>({});
const nameSearch = ref<string>('');
const buttonFilter = ref<string>('imprisonedOrExiled')

const {checkPrisonerFilter} = useFilter()



// Computed property to generate filtered records
const filteredRecords = computed(() => {
  return records.value.filter((record) => {
    return checkPrisonerFilter(record, buttonFilter, cleanFilterObject, nameSearch)
  });
});



watch(filterObject, (newValue, oldValue) => {
  const _filters: Record<string, string[]> = {}
  Object.keys(filterObject.value).forEach((key) => {
    const value = filterObject.value[key]
    if(value && value.length > 0) {
      _filters[key] = value
    }
  })

  cleanFilterObject.value = _filters
}, { deep: true });



return (_ctx: any,_cache: any) => {
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_radio_group, {
        value: buttonFilter.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((buttonFilter).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_radio_button, { value: "imprisonedOrExiled" }, {
            default: _withCtx(() => [
              _createTextVNode("In Custody or Exiled")
            ]),
            _: 1
          }),
          _createVNode(_component_a_radio_button, { value: "" }, {
            default: _withCtx(() => [
              _createTextVNode("All Cases")
            ]),
            _: 1
          }),
          _createVNode(_component_a_radio_button, { value: "inExile" }, {
            default: _withCtx(() => [
              _createTextVNode("In Exile")
            ]),
            _: 1
          }),
          _createVNode(_component_a_radio_button, { value: "inCustody" }, {
            default: _withCtx(() => [
              _createTextVNode("In Custody")
            ]),
            _: 1
          }),
          _createVNode(_component_a_radio_button, { value: "released" }, {
            default: _withCtx(() => [
              _createTextVNode("Released")
            ]),
            _: 1
          }),
          _createVNode(_component_a_radio_button, { value: "awaitingTrial" }, {
            default: _withCtx(() => [
              _createTextVNode("Awaiting Trial")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"]),
      _withDirectives(_createElementVNode("input", {
        type: "search",
        placeholder: "Search by name",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((nameSearch).value = $event))
      }, null, 512), [
        [_vModelText, nameSearch.value]
      ]),
      _createVNode(FiltersComponent, {
        class: "mb-12",
        filters: _unref(filterFieldsObj),
        "model-value": filterObject.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filterObject).value = $event))
      }, null, 8, ["filters", "model-value"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredRecords.value, (record) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (!record['Status Under Review'])
            ? (_openBlock(), _createBlock(CardComponent, {
                record: record,
                key: record.id
              }, null, 8, ["record"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 256))
    ])
  ]))
}
}

})